import React, { useEffect } from "react";
import { useCart } from "../context/CartContext.tsx";

const PurchaseCompleted = () => {
  const { clearCart } = useCart();

  useEffect(() => {
    // Töm varukorgen när sidan mountas
    clearCart();
  }, [clearCart]);

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    height: "100vh",
    backgroundColor: "#f4f4f9",
    padding: "20px",
  };

  const contentStyle = {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "30px",
    maxWidth: "500px",
    width: "100%",
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  };

  const headingStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "20px",
  };

  const paragraphStyle = {
    fontSize: "16px",
    color: "#555",
    marginBottom: "20px",
  };

  const buttonStyle = {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <h2 style={headingStyle}>Tack för ditt köp!</h2>
        <p style={paragraphStyle}>
          Vi har mottagit din beställning. En orderbekräftelse kommer att skickas inom kort.
        </p>
        <button
          style={buttonStyle}
          onClick={() => (window.location.href = "/")}
        >
          Tillbaka till hemsidan
        </button>
      </div>
    </div>
  );
};

export default PurchaseCompleted;
